/**
 * Helper function per ottenere le risposte tradotte
 * @param {Array|Object} risposte - Array di stringhe o oggetti con le risposte nella lingua di default
 * @param {Object} risposteTranslations - Oggetto con mappa di lingue -> array di risposte tradotte
 * @param {string} currentLanguage - Codice lingua corrente (normalizzato, es. "en")
 * @param {string} defaultLanguage - Codice lingua di default (normalizzato, es. "it")
 * @returns {Array} - Array di risposte nella lingua corrente (stessa lunghezza di risposte)
 */
export const getTranslatedAnswers = (risposte, risposteTranslations, currentLanguage, defaultLanguage) => {
    // Se la lingua corrente è quella di default, usa risposte originale
    if (currentLanguage === defaultLanguage || !risposteTranslations || !Array.isArray(risposte)) {
        return risposte;
    }
    
    // Cerca la traduzione
    let translatedArray = null;
    
    if (risposteTranslations && typeof risposteTranslations === 'object') {
        // Prova prima con il codice lingua normalizzato (es. "en")
        if (risposteTranslations[currentLanguage] && Array.isArray(risposteTranslations[currentLanguage])) {
            translatedArray = risposteTranslations[currentLanguage];
        } else {
            // Se non trovato, cerca anche varianti possibili (es. "en-GB", "en-US" per "en")
            const possibleKeys = Object.keys(risposteTranslations).filter(key => {
                const normalizedKey = key.split('-')[0].toLowerCase();
                return normalizedKey === currentLanguage && Array.isArray(risposteTranslations[key]);
            });
            
            if (possibleKeys.length > 0) {
                translatedArray = risposteTranslations[possibleKeys[0]];
            }
        }
    }
    
    // Se non abbiamo trovato traduzioni, usa risposte originali
    if (!translatedArray) {
        return risposte;
    }
    
    // Garantisci che l'array risultante abbia sempre la stessa lunghezza di risposte
    // Supporta traduzioni parziali: usa traduzione se disponibile, altrimenti originale
    return risposte.map((original, index) => {
        return translatedArray[index] !== undefined && translatedArray[index] !== null 
            ? translatedArray[index] 
            : original;
    });
};

